import { render, staticRenderFns } from "./PaymentMethodNewCreditCard.vue?vue&type=template&id=2aea00ca&"
import script from "./PaymentMethodNewCreditCard.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodNewCreditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports